import { render, staticRenderFns } from "./publicityCategoryDetail.vue?vue&type=template&id=5eb8282c"
import script from "./publicityCategoryDetail.vue?vue&type=script&lang=js"
export * from "./publicityCategoryDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports